module.exports = {"421126100":"漕河镇","421126101":"赤东镇","421126102":"蕲州镇","421126103":"管窑镇","421126104":"彭思镇","421126105":"横车镇","421126106":"株林镇","421126107":"刘河镇","421126108":"狮子镇","421126109":"青石镇","421126110":"张榜镇","421126111":"大同镇","421126112":"檀林镇","421126200":"向桥乡","421126450":"八里湖农场","421126451":"李时珍医药工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421126.json
// module id = 1627
// module chunks = 0